<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="/quota-config" v-if="canView()">
                    ตั้งค่าโควต้า
                </b-nav-item>
                &nbsp
                <b-nav-item router-link to="/quota-list" v-if="canView()">
                    รายการจองโควต้า
                </b-nav-item>
                &nbsp
                <b-nav-item router-link to="/quota-sale-create" v-if="canView() || canSaleView">
                    จองโควต้า(เซล)
                </b-nav-item>
                &nbsp
                <b-nav-item router-link to="/quota-sale-list" v-if="canView() || canSaleView">
                    ประวัติการจองโควต้า
                </b-nav-item>
                &nbsp
                <b-nav-item router-link to="/quota-sale-history" v-if="canView()">
                    ประวัติการขายเกินโควต้า
                </b-nav-item>
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view/>
        </div>
    </div>
</template>

<script>
import {canSaleView, canViewSuperAdmin} from "@/util/Permissions";
import {mapState} from "vuex";

export default {
    components: {},
    name: "quota-layout",
    computed: {
        canViewSuperAdmin,
        canSaleView,
        ...mapState({
            user: state => {
                return state.Auth.user;
            },
        }),
    },
    methods: {
        canView() {
            let qc = [10223, 10228, 10701, 20648, 20701, 20726, 20729, 20655, 20708, 20683]
            let admin = [20533]
            return (qc.includes(this.user.username) || admin.includes(this.user.username) || canViewSuperAdmin())
        }
    }
};
</script>

<style lang="scss" scoped></style>
